import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { switchMap, map, filter } from 'rxjs/operators';
import { TimeWindowsRes, TimeWindowsService } from '@cemex-core/cmx-api';
import {
  OneClickTimeWindowsActionTypes,
  OneClickLoadTimeWindowsCompleteAction,
  OneClickLoadTimeWindowsAction,
} from '@ordersnproducts/modules/one-click-order/actions/one-click-time-windows.actions';
import {
  OneClickOrdersActionTypes,
  OneClickSelectOrderAction,
} from '@ordersnproducts/modules/one-click-order/actions/one-click-orders.actions';

@Injectable()
export class OneClickTimeWindowsEffects {
  loadTimeWindowsCommand = createEffect(() =>
    this.actions$.pipe(
      ofType(OneClickOrdersActionTypes.SELECT_ORDER),
      map((action: OneClickSelectOrderAction) => {
        return new OneClickLoadTimeWindowsAction(action.payload);
      }),
    ),
  );

  getTimeWindows = createEffect(() =>
    this.actions$.pipe(
      ofType(OneClickTimeWindowsActionTypes.LOAD_TIME_WINDOWS),
      map((action: OneClickLoadTimeWindowsAction) => action.payload),
      filter((order) => !!order),
      switchMap((order) => {
        return this.timeWindowsService
          .getTimeWindows({
            countryCode: order.salesArea.countryCode,
            productLineCode: order.items[0].product.productType.productTypeCode,
            shippingConditionCode: order.shippingCondition.shippingConditionCode,
          })
          .pipe(
            map((response: TimeWindowsRes) => {
              return new OneClickLoadTimeWindowsCompleteAction(response.timewindows);
            }),
          );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private timeWindowsService: TimeWindowsService,
  ) {}
}
